var map = {
	"./TTCommonsBold.ttf": 3117,
	"./TTCommonsBold.woff": 8175,
	"./TTCommonsExtraBold.otf": 539,
	"./TTCommonsExtraBold.ttf": 8918,
	"./TTCommonsExtraBold.woff": 9698,
	"./TTCommonsLight.otf": 4255,
	"./TTCommonsLight.ttf": 545,
	"./TTCommonsLight.woff": 2851,
	"./TTCommonsRegular.otf": 4811,
	"./about_bg.png": 2769,
	"./bg-genres.png": 7001,
	"./bg-hero.mp4": 6754,
	"./bg-hero.webm": 747,
	"./bg-latest-updates-store.png": 9889,
	"./bg-latest-updates-uplay.png": 8909,
	"./bg-reinsurance.svg": 6674,
	"./bg-subscribe.svg": 1955,
	"./buttonAppStore.svg": 6744,
	"./buttonGooglePlay.svg": 1893,
	"./cable.jpg": 1299,
	"./cero-b.jpg": 9020,
	"./check.png": 7204,
	"./classind-l.jpg": 8832,
	"./csrr-12.png": 2421,
	"./download-upc.svg": 8185,
	"./download.svg": 8728,
	"./esrb-t.png": 7571,
	"./exploding-plus-upc.svg": 4641,
	"./exploding-plus.svg": 851,
	"./gamelist.jpg": 6693,
	"./grb-12.png": 5991,
	"./guy.png": 1072,
	"./image-latest-updates.png": 3223,
	"./man_with_phone.png": 6451,
	"./pattern-latest-updates.svg": 879,
	"./pegi-3.png": 5201,
	"./play.svg": 5570,
	"./r_blue.svg": 9823,
	"./r_red.svg": 5851,
	"./r_yellow.svg": 256,
	"./rocksmith-2014.jpg": 5258,
	"./rocksmith-app.jpg": 9499,
	"./shape-reinsurance-upc.svg": 271,
	"./shape-reinsurance.svg": 6076,
	"./shield-upc.svg": 9538,
	"./shield.svg": 7917,
	"./trailer.jpg": 63,
	"./ubisoftsans-bold.otf": 7427,
	"./ubisoftsans-regular.otf": 4505,
	"./usk-6.png": 5104,
	"./woman_with_acoustic_guitar.png": 1398,
	"./woman_with_electric_guitar.png": 1066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;